module.exports = __webpack_public_path__ + "assets/projects/droplet/table-navigation.mp4";


//////////////////
// WEBPACK FOOTER
// ./assets/projects/droplet/table-navigation.mp4
// module id = 47
// module chunks = 0